// extracted by mini-css-extract-plugin
module.exports = {"container":"_3QrE7N mz-default-dark-font"};